export default "__VITE_ASSET__c2ea9e9a__"